export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/mfa/login',
    LOGIN_MFA: '/auth/login/mfa',
    LOGIN_TRY_ANOTHER_WAY: '/auth/login/try-another-way',
    LOGIN_RECOVERY: '/auth/login/recovery',
    LOGIN_PIN: '/auth/login/pin',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD: '/auth/reset-password',
    VERIFY_EMAIL: (token: string) => `/auth/verify-email/${token}`,

    // MFA Endpoints
    MFA_STATUS: '/auth/mfa/status',
    MFA_VERIFY: '/auth/mfa/verify',
    MFA_RESEND_CODE: '/auth/mfa/resend-code',
    MFA_TOTP_SETUP: '/auth/mfa/totp/setup',
    MFA_TOTP_VERIFY: '/auth/mfa/totp/verify',
    MFA_WHATSAPP_SETUP: '/auth/mfa/whatsapp/setup',
    MFA_WHATSAPP_VERIFY: '/auth/mfa/whatsapp/verify',
    MFA_SMS_SETUP: '/auth/mfa/sms/setup',
    MFA_SMS_VERIFY: '/auth/mfa/sms/verify',
    MFA_GMAIL_SETUP: '/auth/mfa/gmail/setup',
    MFA_GMAIL_VERIFY: '/auth/mfa/gmail/verify',
    MFA_TOTP_ENABLE: '/auth/mfa/totp/enable',
    MFA_TOTP_DISABLE: '/auth/mfa/totp/disable',
    MFA_ENABLE: '/auth/mfa/enable',
    MFA_DISABLE: '/auth/mfa/disable',
    MFA_USER_SETTINGS: '/auth/mfa/settings/{userId}',
    MFA_SET_PREFERRED: '/auth/mfa/set-preferred',
    MFA_REMOVE_METHOD: '/auth/mfa/remove-method',
    MFA_BACKUP_CODES: '/auth/mfa/backup-codes',
    MFA_USE_RECOVERY_CODE: '/auth/mfa/use-recovery-code',
    MFA_TRUST_DEVICE: '/auth/mfa/trust-device',
    MFA_TRUSTED_DEVICES: '/auth/mfa/trusted-devices/{userId}',
    MFA_REVOKE_DEVICE: '/auth/mfa/revoke-device'
  },

  USER: {
    PROFILE: '/users/profile',
    LIST: '/users',
    CREATE: '/users',
    UPDATE: (id: string) => `/users/${id}`
  },

  ENTITIES: {
    BASE: '/api/v1/entities',
    BY_ID: (id: string) => `/api/v1/entities/${id}`
  }

};
